<span class="d-flex align-items-center gap-2">
    <span>{{ value }}</span>
    <i
        class="fa-regular"
        [ngClass]="copied ? 'fa-check text-success' : 'fa-copy text-secondary small'"
        role="button"
         [title]="copied ? ( 'shared.copied' | transloco ): ( 'shared.copy' | transloco )"
        (click)="copy()">
    </i>
</span>
